export default function duplicateUntil(paramData) {
    this.popup('duplicateUntil', {
        params: {
            way: paramData.way,
            module: paramData.module,
            id: paramData.id,
        },
        header: this.translate('LBL_DUPLICATE_UNTIL', paramData.module),
    });
}
